/** Renders a JSON-LD <script> inline in the React tree.
 *  Safer than document.head manipulation (survives Strict Mode) and
 *  Google's crawler reads in-body JSON-LD just fine. */
export const JsonLd = ({ data }) => {
  if (!data) return null;
  // Escape "<" so a "</script>" inside any string value can never break out of the tag.
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
};

const SITE = "https://fedevo20.fr";

/** Given an array of {name, path} segments, renders the BreadcrumbList schema. */
export const BreadcrumbJsonLd = ({ items }) => {
  if (!items || !items.length) return null;
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((it, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": it.name,
      "item": it.path ? `${SITE}${it.path}` : undefined,
    })),
  };
  return <JsonLd data={data} />;
};

/** Renders an ItemList schema for a set of listed entities.
 *  Accepts items as [{ name, path, image?, description? }]. */
export const ItemListJsonLd = ({ name, items, description }) => {
  if (!items || !items.length) return null;
  const data = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": name,
    "description": description,
    "numberOfItems": items.length,
    "itemListOrder": "https://schema.org/ItemListOrderAscending",
    "itemListElement": items.map((it, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "url": it.path ? (it.path.startsWith("http") ? it.path : `${SITE}${it.path}`) : undefined,
      "name": it.name,
      ...(it.image ? { "image": it.image } : {}),
      ...(it.description ? { "description": it.description } : {}),
    })),
  };
  return <JsonLd data={data} />;
};
